import React from 'react'
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { PageContainerToolbar } from '@toolpad/core/PageContainer'
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import {
  setUserRole,
  setGroupManager,
  setAssociateManager,
  setInvoiceModalOpen
} from '../../../store/invoice/invoiceSlice';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Fab from '@mui/material/Fab';
import { Tooltip } from '@mui/material'

const theme = createTheme({
  components: {
    MuiInputBase: {
      defaultProps: {
        size: 'small',
      }
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      }
    },
  }
})

const InvoicePageToolBar = () => {
  const dispatch = useDispatch();
  const {
    selected_user_role,
    selected_group_manager,
    selected_associate_manager,
    is_invoice_modal_open
  } = useSelector((state) => state.invoice);

  const handleUserRoleChange = (event) => {
    const { value } = event.target;
    let newVal = value === undefined ? "" : value;
    dispatch(setUserRole(newVal));
  };
  const handleGroupRoleChange = (event) => {
    const { value } = event.target;
    let newVal = value === undefined ? "" : value;
    dispatch(setGroupManager(newVal));
  };
  const handleAssociateManagerChange = (event) => {
    const { value } = event.target;
    let newVal = value === undefined ? "" : value;
    dispatch(setAssociateManager(newVal));
  };

  // const handleInvoiceModal = () => {
  //   dispatch(setInvoiceModalOpen(!is_invoice_modal_open));
  // };

  return (
    <PageContainerToolbar sx={{ display: 'flex', justifyContent: 'space-between', marginLeft: 0, width: '80vw', flexDirection: { lg: 'row', md: 'column', xs: 'column' } }}>
      <Tooltip title={`Active: 5 / 48`} arrow>
        <Typography variant="subtitle2" fontWeight={500}
          display='flex' sx={{
            alignItems: { md: 'center', xs: 'flex-start' },
          }}
        >
          {`Active: 5 / 48`}
        </Typography>
      </Tooltip>
      <Box display='flex' sx={{
        flexDirection: { lg: 'row', md: 'column', xs: 'column' },
        alignItems: { md: 'center', xs: 'flex-start' }
      }}>

        <Box sx={{
          '& .MuiFormControl-root,.MuiButtonBase-root': {
            mx: { md: 1, xs: 0 }
          },
          '& .MuiFormControl-root': {
            my: { lg: 0, md: 0.8, xs: 0.8 }
          },
          '& .actionButton': {
            display: { md: 'flex', xs: 'none' }
          },
          width: { md: 'unset', xs: '100%' },
          display: 'flex',
          flexDirection: { lg: 'row', md: 'column', xs: 'column' },
          alignItems: 'center'
        }}>
          <Typography variant='subtitle2' color='textPrimary' fontWeight='500'>Filter By:</Typography>

          <FormControl sx={{ minWidth: { md: 200, xs: '100%' }, maxWidth: { md: 180, xs: '100%' } }}>
            <Select
              endAdornment={
                selected_user_role && (
                  <InputAdornment position='end'>
                    <IconButton size='small' onClick={handleUserRoleChange} sx={{ mr: -1.5 }}>
                      <ClearIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                  </InputAdornment>
                )
              }
              value={selected_user_role}
              size='small'
              onChange={handleUserRoleChange}
              displayEmpty
              sx={{
                fontSize: '13px',
                "& .MuiOutlinedInput-input": {
                  padding: "10px 14px",
                  paddingRight: selected_user_role ? '0px!important' : '32px'
                },
                "& .MuiSelect-icon": {
                  display: selected_user_role ? 'none' : 'block',
                },
              }}
            >
              <MenuItem disabled value="" sx={{ fontSize: '14px' }}>
                <p>Select User Role</p>
              </MenuItem>
              <MenuItem value="1" sx={{ fontSize: '14px' }} >Addnectar</MenuItem>
              <MenuItem value="2" sx={{ fontSize: '14px' }} >Artwork</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: { md: 200, xs: '100%' }, maxWidth: { md: 180, xs: '100%' } }}>
            <Select
              endAdornment={
                selected_group_manager && (
                  <InputAdornment position='end'>
                    <IconButton size='small' onClick={handleGroupRoleChange} sx={{ mr: -1.5 }}>
                      <ClearIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                  </InputAdornment>
                )
              }
              value={selected_group_manager}
              size='small'
              onChange={handleGroupRoleChange}
              displayEmpty
              sx={{
                fontSize: '13px',
                "& .MuiOutlinedInput-input": {
                  padding: "10px 14px",
                  paddingRight: selected_group_manager ? '0px!important' : '32px'
                },
                "& .MuiSelect-icon": {
                  display: selected_group_manager ? 'none' : 'block',
                },
              }}
            >
              <MenuItem disabled value="" sx={{ fontSize: '14px' }}>
                <p>Select Group Manager</p>
              </MenuItem>
              <MenuItem value="1" sx={{ fontSize: '14px' }} >Addnectar</MenuItem>
              <MenuItem value="2" sx={{ fontSize: '14px' }} >Artwork</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: { lg: 200, md: '95%', xs: '100%' }, maxWidth: { lg: 180, md: '90%', xs: '100%' } }}>
            <Select
              endAdornment={
                selected_associate_manager && (
                  <InputAdornment position='end'>
                    <IconButton size='small' onClick={handleAssociateManagerChange} sx={{ mr: -1.5 }}>
                      <ClearIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                  </InputAdornment>
                )
              }
              value={selected_associate_manager}
              size='small'
              onChange={handleAssociateManagerChange}
              displayEmpty
              sx={{
                fontSize: '13px',
                "& .MuiOutlinedInput-input": {
                  padding: "10px 14px",
                  paddingRight: selected_associate_manager ? '0px!important' : '32px'
                },
                "& .MuiSelect-icon": {
                  display: selected_associate_manager ? 'none' : 'block',
                },
              }}
            >
              <MenuItem disabled value="" sx={{ fontSize: '14px' }}>
                <p>Select Associate Manager</p>
              </MenuItem>
              <MenuItem value="1" sx={{ fontSize: '14px' }} >Addnectar</MenuItem>
              <MenuItem value="2" sx={{ fontSize: '14px' }} >Artwork</MenuItem>
            </Select>
          </FormControl>
          {/* <ThemeProvider theme={theme}>
            <FormControl 
            sx={{
              '& .MuiStack-root' : {
                pt:0
              }
            }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer 
              components={['DatePicker']}
              >
                <DatePicker label="Invoice Date Range" />
              </DemoContainer>
            </LocalizationProvider>
            </FormControl>
          </ThemeProvider> */}
        </Box>
      </Box>
    </PageContainerToolbar>
  )
}

export default InvoicePageToolBar;